import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-font-minus",
  "use": "icon-font-minus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-font-minus\"><path d=\"M414.531 46.583L0 977.417h97.825l136.953-305.292H613.85l138.182 305.292h94.154L436.543 46.583h-22.012zM275.133 581.161l150.405-336.445 149.184 336.445H275.133z m392.242-401.505v88.568h356.558v-88.568H667.375z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/font-minus.svg
// module id = m9xa
// module chunks = 65